var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":""}},[_c('v-spacer'),_c('div',{staticClass:"mr-2"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" Selflane.com")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }